import Event from '../../core/Event';
import { ArticleOrderDraft } from '../../../domain/Order';
import initialState from '../../core/initialState';
import State from '../State';
import updateArticleOrder from './updateArticleOrder';
import OrderChangeConfirmed from '../events/OrderChangeConfirmed';

export default (state: State = initialState.order, anyEvent: Event): State => {
    const event: OrderChangeConfirmed = anyEvent as OrderChangeConfirmed;
    if (event.value < 0) {
        return state;
    }
    let articlesOrdersDrafts: ArticleOrderDraft[] = state.order!.articlesOrdersDrafts;
    if (containsOrder(articlesOrdersDrafts, event.product.articleId)) {
        articlesOrdersDrafts = updateArticleOrder(
            articlesOrdersDrafts,
            event.product,
            event.sku,
            event.variantCode,
            event.value,
            event.field
        );
    } else {
        articlesOrdersDrafts = [
            ...articlesOrdersDrafts,
            {
                articleId: event.product.articleId,
                wholesalePrice: event.product.wholesalePrice,
                discountCodeASet: event.product.discountCodeASet,
                itemsOrdersDrafts: [
                    {
                        sku: event.sku,
                        variantCode: event.variantCode,
                        toOrderFromEstimation: 0,
                        toOrderFromStock: 0,
                        [event.field]: event.value
                    }
                ]
            }
        ];
    }
    return {
        ...state,
        order: {
            ...state.order!,
            articlesOrdersDrafts
        }
    };
};

export const containsOrder = (orders: ArticleOrderDraft[], articleId: string): boolean =>
    orders.find((order: ArticleOrderDraft) => order.articleId === articleId) !== undefined;



// WEBPACK FOOTER //
// ./src/application/order/reducer/orderChangeConfirmed.ts